import Vue from 'vue';
import '@/assets/stylesheets/v2/_base-details.scss';
export default Vue.extend({
    props: {
        label: {
            type: String,
            required: true,
        },
        content: {
            type: String,
            default: null,
        },
        capitalized: {
            type: Boolean,
            default: false,
        },
    },
    render(createElement) {
        return createElement('div', {
            class: 'base-details',
        }, [
            createElement('div', {
                class: 'label',
            }, this.label),
            createElement('p', {
                class: {
                    content: true,
                    '-capitalized': this.capitalized,
                },
            }, this.$slots.default || this.content),
        ]);
    },
});
